import { call, select, put } from 'redux-saga/effects';
import { loadQuote } from './api';
import { getQuoteId } from '../selectors';
import { Creators as actions } from '../actions';

/**
 * Trigger the loadQuote saga to refresh the quote and hide the confirmation message
 */
function* refreshQuote() {
    const quoteId = yield select(getQuoteId);

    yield call(loadQuote, quoteId);
    // yield put(actions.setQuoteChanged(false));
}

export default refreshQuote;
